// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3aWMS","options":"AnswerScale_options__2DzHv","selected":"AnswerScale_selected__20wFl"};